export * from './types'
export * from './viewProps'

const isa = Array.isArray

export function compile<S>(style?: S): any {
  return style ? bakeAll(style) : undefined
}

function bakeAll<S>(style?: S) {
  const result: any = {}
  if (isa(style)) {
    for (const s of style as any[]) {
      bakeInto(result, s)
    }
    return result
  }
  return bakeInto(result, style)
}

function bakeInto(result: any, style: any) {
  if (style) {
    const keys = Object.keys(style)
    for (const key of keys) {
      result[key] = style[key]
    }
  }
  return result
}
